const brSplit = {
  split: {
    label: {
      host: 'Host',
      vendor: 'Fornecedor',
      hauseful: 'Hauseful',
      partner: 'Parceiro',
      tax: 'Repasse',
      taxes: 'Repasses',
      mode: 'Modo',
      description: 'Descrição',
      hostTakeRate: 'Repasse host',
      customerTakeRate: 'Repasse cliente',
      hausefulTakeRate: 'Repasse Hauseful',
      partnerTakeRate: 'Repasse parceiro',
      fixAmount: 'Valor fixo',
      percentage: 'Porcentagem',
      monetary: 'Monetário',
      active: 'ativa',
      inactive: 'inativa',
      customer: 'Cliente',
    },

    hints: {
      delete: 'Deseja mesmo apagar esta configuração?',
    },

    action: {
      cancel: 'Cancelar',
      delete: 'Apagar configuração de split',
      edit: 'Editar configuração de split',
      create: 'Criar configuração de split',
      loading: 'Carregando configuração de split',
    },

    messages: {
      successfullyCreated: 'Split de configuração criado com sucesso',
      successfullyUpdated: 'Split de configuração atualizado com sucesso',
      successfullyDeleted: 'Split de configuração removido com sucesso',
    },
  },
}

export default brSplit
